<template>
  <div class="container">
    <mt-header fixed :title="title" class="head" >
      <router-link to="/imgupdate" slot="left">
        <mt-button icon='back'></mt-button>
      </router-link>
      <mt-button slot="right" v-show="auth.editable" @click="commit">提交</mt-button>
    </mt-header>
    <div class="form">
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          楼盘名称
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value ">
                    <input type="text" @change="autoSave('village',village)" placeholder="请填写楼盘名称" v-model="village">
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white" :class="auth.editable?'':'c_no_pointer'" @click="typeClick">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          屋面类型
        </div>
        <div class="item-content">
                <span class="item-value c_no_pointer">
                  <input type="text" @change="autoSave('type',type)" placeholder="请选择屋面类型" v-model="type">
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          屋面构造层次
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                    <input type="text" @change="autoSave('layer',layer)" placeholder="请填写屋面构造层次" v-model="layer">
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          屋面构造厚度
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                    <input type="text" @change="autoSave('thickness',thickness)" placeholder="请填写屋面构造厚度" v-model="thickness">
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          维修面积
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                    <input type="number" @change="autoSave('area',area)" placeholder="请填写维修面积" v-model="area">
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          渗透时长
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                    <input type="text" @change="autoSave('time',time)" placeholder="请填写渗透时长" v-model="time">
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          渗透原因
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                  <input type="text" @change="autoSave('reason1',reason1)" placeholder="请填写渗透原因" v-model="reason1">
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          输入必要信息
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                    <input type="text" @change="autoSave('msg',msg)" placeholder="请填写必要信息" v-model="msg">
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          <!--<span class="c_red">*</span>-->
          备注
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value ">
                    <input type="text" @change="autoSave('memo',memo)" placeholder="请填写备注" v-model="memo">
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          是否维修过
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                   <mt-switch v-model="isRepaired"></mt-switch>
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          维修方案是否提供
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                   <mt-switch v-model="plan"></mt-switch>
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          维修报价是否提供
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                   <mt-switch v-model="price"></mt-switch>
                </span>
        </div>
      </div>
      <div class="item-group c_m_b_10 bg_white">
        <div class="item-title c_nowrap">
          是否选择维修
        </div>
        <div class="item-content" :class="auth.editable?'':'c_no_pointer'">
                <span class="item-value">
                   <mt-switch v-model="isRepair"></mt-switch>
                </span>
        </div>
      </div>
    </div>
    <div class="procedure">
      <div class="procedure-group">
        <div class="procedure-title">屋面整体</div>
        <div class="procedure-content">
          <div class="c_rela procedure-img" v-for="(n,index) in img_roof" :key="index" v-if="index<3">
            <div class="imgdel" v-show="auth.editable" @click="delClick('img_roof',index)">×</div>
            <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
          </div>
          <update-file v-show="img_roof && (img_roof.length<3) && auth.editable" @fileChange="getUrl($event,'img_roof')"></update-file>
        </div>
      </div>
      <div class="procedure-group">
        <div class="procedure-title">室内渗漏部位</div>
        <div class="procedure-content">
          <div class="c_rela procedure-img" v-for="(n,index) in img_indoor" :key="index" v-if="index<3">
            <div class="imgdel" v-show="auth.editable" @click="delClick('img_indoor',index)">×</div>
            <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
          </div>
          <update-file v-show="img_indoor && (img_indoor.length<3) && auth.editable" @fileChange="getUrl($event,'img_indoor')"></update-file>
        </div>
      </div>
      <div class="procedure-group">
        <div class="procedure-title">问题节点</div>
        <div class="procedure-content">
          <div class="c_rela procedure-img" v-for="(n,index) in img_node" :key="index" v-if="index<3">
            <div class="imgdel" v-show="auth.editable" @click="delClick('img_node',index)">×</div>
            <img :src="qiniu+n+'?imageView2/1/w/100/h/100'" :data-src="qiniu+n" @click="imgShowClick" class="" />
          </div>
          <update-file v-show="img_node && (img_node.length<3) && auth.editable" @fileChange="getUrl($event,'img_node')"></update-file>
        </div>
      </div>
    </div>

    <!--  选择房屋类型  -->
    <mt-actionsheet
      :actions="type_params.actions"
      v-model="type_params.type_visible">
    </mt-actionsheet>
    <!--图片显示-->
    <c-imgshow @part_close="part_close" :ispart_imgshow="ispart_imgshow" :imgshow_url="imgshow_url">
    </c-imgshow>

  </div>
</template>
<script>
  import axios from 'axios'
  import {Indicator, MessageBox} from 'mint-ui';
  import UpdateFile from './update-file';
  import CImgshow from './c-imgshow';
  export default {
    components:{UpdateFile,CImgshow},
    data(){
      return{
        qiniu:this.$$api.mobile.qiniuDownload,
        title:'',
        sid:'',
        formid:'',
        img_roof:[],
        img_indoor:[],
        img_node:[],
        village:'',//楼盘名称
        type:'',//屋面类型
        memo:'',//备注
        layer:'',//屋面构造层次
        thickness:'',//屋面构造厚度
        area:'',//维修面积
        time:'',//渗透时长
        msg:'',//必要信息
        isRepaired:false,//是否维修过
        plan:false,//维修方案
        price:false,//维修报价
        isRepair:false,//是否选择维修
        reason1:'',//渗透原因①
        reason2:'',//渗透原因②
        method:'',//维修做法
        // 选择屋面类型
        type_params:{
          type_visible:false,
          actions:[
            {
              name: '平屋面/上人屋面',
              method : this.saveTypeClick,
            },
            {
              name: '平屋面/非上人屋面',
              method : this.saveTypeClick,
            },
            {
              name: '坡屋面/沥青瓦屋面',
              method : this.saveTypeClick,
            },
            {
              name: '坡屋面/水泥或陶瓷瓦屋面',
              method : this.saveTypeClick,
            },
            {
              name: '金属屋面/彩钢屋面',
              method : this.saveTypeClick,
            },
            {
              name: '金属屋面/阳光房',
              method : this.saveTypeClick,
            },
          ],
        },
        // 图片显示
        ispart_imgshow:false,
        imgshow_url:'',
        // 权限控制
        auth:{
          //是否开始自动保存
          isAutoSave:false,
          //是否有提交权限
          editable:false,
          //是否-- 可以提交
          isCommit:true,
        },
      }
    },

    mounted(){
      var obj = JSON.parse(localStorage['obj']);
      var procedure = obj.procedure;
      this.sid = procedure.billbid;
      this.formid = procedure.formid;
      this.itemid = procedure.itemid;
      this.title = procedure.itemname;
      this.load();
      this.getAuth();
    },
    methods:{
      // 获取工序详情
      load:function(){
        var $that = this;
        this.$ajax.get(this.$$api.mobile.getProcedureDetail,{
          'sid':this.sid,
          'formid':this.formid
        },function (res) {
          if(res.status ==200) {
            var obj = res.data.detailMsg.data;
            $that.img_roof = obj.img_roof ? (obj.img_roof.split(',')||[]):[];
            $that.img_indoor = obj.img_indoor ? (obj.img_indoor.split(',')||[]):[];
            $that.img_node = obj.img_node ? (obj.img_node.split(',')||[]):[];
            $that.img_roof = obj.img_roof ? (obj.img_roof.split(',')||[]):[];
            $that.village = obj.village;
            $that.memo = obj.memo;
            $that.layer = obj.layer;
            $that.thickness = obj.thickness;
            $that.area = obj.area;
            $that.time = obj.time;
            $that.msg = obj.msg;
            $that.isRepaired = (obj.isRepaired == 'true')||false;
            $that.plan = (obj.plan == 'true')||false;
            $that.price = (obj.price == 'true')||false;
            $that.isRepair = (obj.isRepair == 'true')||false;
            $that.type = obj.type;
            $that.reason1 = obj.reason1;
            $that.reason2 = obj.reason2;
            $that.method = obj.method;
          }
          setTimeout(function(){
            $that.auth.isAutoSave = true;
          },500);
        });
      },
      // 获取当前用户权限
      getAuth:function(){
        var $that = this;
        this.$ajax.get(this.$$api.mobile.getProcedureAuth,{
          'itemid':this.itemid,
          'billbid':this.sid,
        },function (res) {
          if(res.status ==200) {
            var obj = res.data.detailMsg.data;
            $that.auth.editable = obj.editable == 'Y'? true:false;
          }
        });
      },
      // 选择房屋类型
      typeClick:function(){
        this.type_params.type_visible = true;
      },
      saveTypeClick:function(obj){
        this.type = obj.name;
        this.autoSave('type',obj.name);
      },
      autoSave(type,value){
        if(type && this.sid &&this.formid && this.auth.isAutoSave) {
          this.$ajax.get(this.$$api.mobile.saveProcedure, {
            'sid':this.sid,
            'formid':this.formid,
            'attribute':type,
            'value':value
          },response=>{
            if (response.status >= 200 && response.status < 300) {
              // console.log(response);
            } else {
              // console.log(response,this.sid);
            }
          });
        }
      },
      getUrl(e,val){
        var $that = this;
        // var file = e.files[0];
        var file =this.$comm.toBase64(e.base64);
        if(val=='img_roof'){
          this.imgFile('img_roof',file,function (url) {
            $that.img_roof.push(url);
          });
          Indicator.close();
        }else if(val=='img_indoor'){
          this.imgFile('img_indoor',file,function (url) {
            $that.img_indoor.push(url);
          });
          Indicator.close();
        }else if(val=='img_node'){
          this.imgFile('img_node',file,function (url) {
            $that.img_node.push(url);
          });
          Indicator.close();
        }
      },
      // 上传图片
      imgFile:function(type,file,fun){
        var $that = this;
        $that.$indicator.open();
        this.$ajax.get(this.$$api.mobile.getimgtoken,{},function (res) {
          if(res.status == 200){
            var token = res.data.token;
            var fileid = res.data.fileid;
            let param = new FormData(); //创建form对象
            param.append('file',file,file.name);//通过append向form对象添加数据
            param.append('chunk','0');//添加form表单中其他数据
            param.append('token',token);//添加form表单中其他数据
            param.append('key',fileid);//添加form表单中其他数据
            let config = {
              headers:{'Content-Type':'multipart/form-data'}
            };
            axios.post($that.$$api.mobile.qiniuUpload,param,config)
              .then(data=>{
                var key = data.data.key;
                if(fun)fun(key);
                $that.$indicator.close();
              });
          }
        });

      },
      // 删除图片
      delClick:function(type,index){
        if(type == 'img_roof'){
          var arr = this.img_roof;
          arr.splice(index,1);
          this.img_roof = arr;
        }else if(type == 'img_indoor'){
          var arr = this.img_indoor;
          arr.splice(index,1);
          this.img_indoor = arr;
        }else if(type == 'img_node'){
          var arr = this.img_node;
          arr.splice(index,1);
          this.img_node = arr;
        }
      },
      commit:function () {
        var $that = this;
        //判断 --
        // if(!this.village){ this.$toast("请填写楼盘名称"); return;}
        // if(!this.type){ this.$toast("请选择屋面类型"); return;}
        // if(!this.layer){ this.$toast("请填写屋面构造层次"); return;}
        // if(!this.thickness){ this.$toast("请填写屋面构造厚度"); return;}
        // if(!this.area){ this.$toast("请填写维修面积"); return;}
        // if(!this.time){ this.$toast("请填写渗透时长"); return;}
        // if(!this.reason1){ this.$toast("请填写渗透原因"); return;}
        // if(!this.msg){ this.$toast("请填写必要信息"); return;}
        // if(this.img_roof.length <3){ this.$toast("请上传最少三张屋面整体图片");return;}
        // if(this.img_indoor.length <3){ this.$toast("请上传最少三张室内渗漏部位图片");return;}
        // if(this.img_node.length <3){ this.$toast("请上传最少三张问题节点图片");return;}
        if(!this.auth.isCommit){return;}
        this.auth.isCommit = false;
        this.auth.editable = false;
        this.$ajax.post(this.$$api.mobile.commitProcedure,{
          'sid':this.sid,
          'formid':this.formid,
        },function (res) {
          $that.$router.push('/imgupdate');
        },function () {
          $that.auth.isCommit = true;
          $that.auth.editable = true;
        });
      },
      // 图片预览
      imgShowClick:function (e) {
        var url = e.currentTarget.dataset.src;
        if(url){
          this.imgshow_url = url;
          this.ispart_imgshow = true;
        }
      },
      part_close:function (value) {
        this.ispart_imgshow = value;
      },
    },
    watch:{
      isRepaired(){
        this.autoSave('isRepaired',this.isRepaired);
      },
      plan(){
        this.autoSave('plan',this.plan);
      },
      price(){
        this.autoSave('price',this.price);
      },
      isRepair(){
        this.autoSave('isRepair',this.isRepair);
      },
      img_roof(){
        this.autoSave('img_roof',(this.img_roof).join(','));
      },
      img_indoor(){
        this.autoSave('img_indoor',(this.img_indoor).join(','));
      },
      img_node(){
        this.autoSave('img_node',(this.img_node).join(','));
      },
    }
  }
</script>
<style scoped>
  .container{
    font-size:4vw;
  }
  ::-webkit-input-placeholder {
    font-size: 3vw;
    color: rgb(184,195,206);
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .item-group {
    width: 100%;
    box-sizing: border-box;
    word-wrap: break-word;
    padding: 3.226vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .item-title {
    width: 50%;
    text-align: left;
    height: 100%;

  }

  .item-content {
    width: 50%;
    text-align: right;
    font-size: 4vw;
    /*background: blue;*/
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .item-content input {
    font-size: 4vw;
  }

  .item-value {
    width: 90%;
    display: inline-block;
    height: 100%;
    padding: 0;
    margin: 0;
    color:#000;
  }

  .item-value input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    text-align: right;
    padding: 0;
    margin: 0;
    display: flex;
    align-content: center;
  }
  >>> .mint-switch{
    justify-content: flex-end;
  }

</style>






// WEBPACK FOOTER //
// src/components/surveyform-1.vue